import React from 'react';
import Appbase from 'appbase-js';
import { Card, Icon, Empty, Row, Col, Spin, Button } from 'antd';
import { css } from '@emotion/css';
import Navbar from '../components/Navbar';

import { getDescriptionFromAPI } from '../utils';
import { APP, CRED, URL, TYPE } from '../constants';

const bookCardStyles = css`
	margin: 10px;

	.book-image {
		text-align: center;
		width: 80%;
		max-height: 100%;
		@media (max-width: 768px) {
			width: 20%;
			margin: 0 auto;
		}
		@media (max-width: 425px) {
			width: 40%;
			margin: 0 auto;
		}
	}

	.book-details {
		h1 {
			font-size: 2rem;
			font-weight: 600;
			margin-bottom: 0;
			color: black;
		}
		h2 {
			font-size: 1.8rem;
			color: #595959;
			margin: 0 0 0.5em;
		}
		p {
			font-size: 1.4rem;
			color: #8c8c8c;
			margin: 0.5em 0;
		}
		a {
			font-size: 1.2rem;
			margin-bottom: 1em;
		}

		@media (max-width: 1024px) {
			h2 {
				font-size: 1.4rem;
			}
			p {
				font-size: 1rem;
			}
			a {
				font-size: 1rem;
			}
		}
		@media (max-width: 768px) {
			h1 {
				font-size: 1.4rem;
			}
			h2 {
				font-size: 1.2rem;
			}
			p {
				font-size: 0.8rem;
			}
			a {
				font-size: 0.8rem;
			}
		}
	}
`;

const notFound = css`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	.back-button {
		margin-top: 20px;
	}
`;

/*
	This component is use to render Book Details.

	Here we are fetching details for specific book by its id using appbase-js.
	And as we dont have proper description of every book, we are calling DuckDuckGo
	API to fetch this detail.
*/

class Book extends React.Component {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			book: null,
			loadingDescription: false,
		};
		this.appbaseRef = Appbase({
			url: URL,
			app: APP,
			credentials: CRED,
		});
	}

	componentDidMount() {
		this.loadBook();
	}

	componentDidUpdate(prevProps) {
		const {
			location: { pathname },
		} = prevProps;
		const {
			location: { pathname: newPath },
		} = this.props;

		if (newPath !== pathname) {
			this.loadBook();
		}
	}

	loadBook = async () => {
		const {
			match: {
				params: { id },
			},
		} = this.props;
		this.setState({
			isLoading: true,
			book: null,
		});
		const bookDetails = await this.appbaseRef.get({
			type: TYPE,
			id,
		});

		if (bookDetails.found) {
			this.setState({
				book: { ...bookDetails._source },
				isLoading: false,
				loadingDescription: true,
			});
			const description = await getDescriptionFromAPI(bookDetails._source.original_title);
			this.setState({
				book: { ...bookDetails._source, description },
				loadingDescription: false,
			});
		} else {
			this.setState({
				isLoading: false,
			});
		}
	};

	getIconsKey = stars => {
		const starsKey = [];
		for (let i = 1; i <= stars; i += 1) {
			starsKey.push(`star_${i}`);
		}

		return starsKey;
	};

	getLink = () => {
		const { book } = this.state;
		const parsedTitle = book.original_title.split(' ').join('+');

		return `https://www.google.com/search?q=${parsedTitle}`;
	};

	render() {
		// eslint-disable-next-line
		const { isLoading, book, loadingDescription } = this.state;
		const { history } = this.props;

		// if (isLoading) {
		// 	return <Spin tip="Fetching data..." />;
		// }
		/* eslint-disable no-nested-ternary */
		return (
			<React.Fragment>
				<Navbar hideShowButton={false} searchId="book-search" />
				{isLoading ? (
					<div
						style={{
							position: 'absolute',
							left: '50%',
							top: '50%',
							transform: 'translate(-50%, -50%)',
						}}
					>
						<Spin tip="Fetching data..." />
					</div>
				) : book ? (
					<Card className={bookCardStyles} bodyStyle={{ display: 'flex' }}>
						<Row gutter={24}>
							<Col span={6} md={6} xs={24}>
								<img
									src={book.image}
									className="book-image"
									alt={book.original_title}
								/>
							</Col>
							<Col span={18} md={18} xs={24} className="book-details">
								<h1>{book.original_title}</h1>
								<h2>By {book.authors.join(', ')}</h2>

								{this.getIconsKey(book.average_rating_rounded).map(iconId => (
									<Icon
										type="star"
										theme="filled"
										key={iconId}
										style={{
											color: '#faad14',
											marginRight: 2,
											fontSize: '1.4em',
										}}
									/>
								))}
								<p>
									{loadingDescription ? (
										<Spin tip="Fetching description..." />
									) : (
										book.description
									)}
								</p>
								<a href={this.getLink()} target="_blank" rel="noopener noreferrer">
									Search on Web
								</a>
							</Col>
						</Row>
					</Card>
				) : (
					<div className={notFound}>
						<Empty description="No Book Found" />
						<Button
							size="large"
							className="back-button"
							onClick={() => history.push('/')}
						>
							<Icon type="arrow-left" />
							Go back
						</Button>
					</div>
				)}
			</React.Fragment>
		);
		/* eslint-enable no-nested-ternary */
	}
}

export default Book;
